import React from "react";

const MemberData = () => {
  return <div>MemberData</div>;
};

export default MemberData;
